import { render, staticRenderFns } from "./TeamsCategory.vue?vue&type=template&id=1fdf4b9c&"
import script from "./TeamsCategory.vue?vue&type=script&lang=js&"
export * from "./TeamsCategory.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports